import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { leaveTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import BetterControlledTable from "../../../component/BetterControlledTable";
import { approveLeave, createLeave, getLeaves } from "../../../api/leaves";
import { CheckCircle, HighlightOff } from "@mui/icons-material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function LeaveManagement({ refreshApi }) {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  addAdditionalColumn(obj, dispatch, user);

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  function refreshTable(e) {
    e?.preventDefault();
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getRows(limit, offset) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    try {
      const { data } = await getLeaves(
        {
          year: selectedYear,
          limit,
          offset,
        },
        user.token
      );
      return {
        rows: data.data.leaves,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  useEffect(() => {
    refreshTable();
  }, [selectedYear]);
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h1" className="pmt-headings-h1">
            Leave Management
          </Typography>

          <Box marginLeft={1} width={200} display="flex" alignItems="center">
            <FormControl fullWidth>
              <InputLabel id="year-label">Year</InputLabel>
              <Select
                labelId="year-label"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {Array.from(
                  { length: 24 },
                  (_, i) => new Date().getFullYear() - i
                ).map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add
        </Button>
      </Box>
      <br />

      <div className="pmt-controll-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getRows}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </div>

      <AddLeaveDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
        refreshApi={refreshApi}
        disableEscapeKeyDown
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch, user) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      minWidth: 70,
      resizable: true,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <>
          <IconButton
            color="info"
            onClick={() => {
              dispatch({ type: "VIEW", data: params.data });
            }}
          >
            <VisibilityIcon fontSize="inherit" />
          </IconButton>
          {/* {user.role === "Admin" ? (
            <>
              <IconButton
                color="info"
                title="Approve"
                onClick={() => {
                  dispatch({ type: "VIEW", data: params.data });
                }}
              >
                <CheckCircle fontSize="inherit" />
              </IconButton>
              <IconButton
                color="info"
                title="Reject"
                onClick={() => {
                  dispatch({ type: "VIEW", data: params.data });
                }}
              >
                <HighlightOff fontSize="inherit" />
              </IconButton>
            </>
          ) : (
            <></>
          )} */}
        </>
      ),
    });
  }
}

const emptyNewLeaveData = {
  type_of_leave: "",
  reason_of_leave: "",
  start_date: "",
  end_date: "",
  status: "pending",
  day_off: "",
};
// ... (import statements)

function AddLeaveDialog({ open, setOpen, onRefresh, refreshApi }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewLeaveData);
  const [dayOffChange, setDayOffChange] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewLeaveData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewLeaveData);
    }
  }, [open]);

  async function onNewLeaveSubmit(data) {
    // console.log("dtta===", data);
    // return;
    const newData = { ...data };
    newData.start_date = createDateAsUTC(newData.start_date);

    if (dayOffChange === true) {
      delete newData.end_date;
    } else {
      newData.end_date = createDateAsUTC(newData.end_date);
    }

    try {
      const { data } = await createLeave(newData, user.token);
      dispatch(showAlert(data.msg));
      setDayOffChange(false);
      setStartDate("");
      setEndDate("");
      setOpen(false);
      refreshApi();
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
      setDayOffChange(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle>Apply for Leave</DialogTitle>
      <Box component="form" onSubmit={onNewLeaveSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="name"
                label="Name"
                required
                fullWidth
                inputRef={register({
                  required: "Name is required.",
                })}
                error={Boolean(errors.name)}
                helperText={errors.name?.message}
              />
            </Grid> */}

            <Grid item xs={12} md={6} sm={6}>
              <FormControl
                fullWidth
                required
                error={Boolean(errors.type_of_leave)}
              >
                <InputLabel id="leave-type-label">Type Of Leave</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      onChange={props.onChange}
                      MenuProps={{ className: "select-box-height" }}
                    >
                      <MenuItem value="" disabled>
                        --select--
                      </MenuItem>
                      <MenuItem value="Casual Leave">Casual Leave</MenuItem>
                      <MenuItem value="Privilege Leave">
                        Privilege Leave
                      </MenuItem>
                      <MenuItem value="Sick Leave">Sick Leave</MenuItem>
                    </Select>
                  )}
                  name="type_of_leave"
                  label="Type Of Leave"
                  control={control}
                  rules={{
                    required: "Type of Leave is required.",
                  }}
                />
                <FormHelperText>{errors.type_of_leave?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <FormControl fullWidth required error={Boolean(errors.day_off)}>
                <InputLabel id="leave-type-label">Day Off</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      //   onChange={props.onChange}
                      onChange={(e) => {
                        props.onChange(e);
                        if (e.target.value === "Half Day") {
                          setDayOffChange(true);
                        } else {
                          setDayOffChange(false);
                        }
                      }}
                      MenuProps={{ className: "select-box-height" }}
                    >
                      <MenuItem value="" disabled>
                        --select--
                      </MenuItem>
                      <MenuItem value="Full Day">Full day</MenuItem>
                      <MenuItem value="Half Day">Half-day</MenuItem>
                      {/* <MenuItem value="Day Off">Day Off</MenuItem> */}
                    </Select>
                  )}
                  name="day_off"
                  label="Day Off"
                  control={control}
                  rules={{
                    required: "Day Off is required.",
                  }}
                />
                <FormHelperText>{errors.day_off?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} sm={6}>
              <FormControl fullWidth error={Boolean(errors.start_date)}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        shouldDisableDate={disablePrevDates(endDate)}
                        onChange={(nv) => {
                          props.onChange(nv);

                          setStartDate(nv);
                          //   startDate(e.target.value);
                        }}
                        // shouldDisableDate={disablePrevDates(
                        //   dayjs(new Date()).subtract(1, "days").toJSON()
                        // )}
                        label="Start Date"
                        // onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.start_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: "Start Date is required.",
                    }}
                    name="start_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>{errors.start_date?.message}</FormHelperText>
              </FormControl>
            </Grid>
            {dayOffChange ? (
              <></>
            ) : (
              <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth error={Boolean(errors.end_date)}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Controller
                      render={(props) => (
                        <DesktopDatePicker
                          value={props.value || ""}
                          shouldDisableDate={disablePrevDates(startDate)}
                          label="End Date"
                          disabled={startDate === "" ? true : false}
                          //   onChange={props.onChange}
                          onChange={(nv) => {
                            props.onChange(nv);

                            setEndDate(nv);
                            //   startDate(e.target.value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              error={Boolean(errors.end_date)}
                              {...params}
                            />
                          )}
                        />
                      )}
                      rules={{
                        required: "End Date is required.",
                      }}
                      name="end_date"
                      control={control}
                    />
                  </LocalizationProvider>
                  <FormHelperText>{errors.end_date?.message}</FormHelperText>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} md={12} sm={12}>
              <TextField
                name="reason_of_leave"
                label="Reason of Leave"
                multiline={true}
                rows={5}
                required
                fullWidth
                inputRef={register({
                  required: "Reason of Leave is required.",
                })}
                error={Boolean(errors.reason_of_leave)}
                helperText={errors.reason_of_leave?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              setStartDate("");
              setEndDate("");
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            className="blue-button"
            onClick={handleSubmit(onNewLeaveSubmit)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}
